import React, { PureComponent } from "react";
import styled from "styled-components";
import Button from "../elements/Button";

const ButtonWrapper = styled.div`
  margin: 20px 0;
`;

class ApplyButton extends PureComponent {
  render() {
    const { clickHandler } = this.props;

    return (
      <ButtonWrapper>
        <Button isPrimary onClick={clickHandler}>
          Apply
        </Button>
      </ButtonWrapper>
    );
  }
}

export default ApplyButton;



// WEBPACK FOOTER //
// ./src/components/filters/ApplyButton.js